import React from 'react';
import AdminHeader from './AdminHeader';

function AdminLayout({ children }) {
  return (
    <div className="admin-layout">
      <AdminHeader />
      <main className="admin-content">
        {children}
      </main>
    </div>
  );
}

export default AdminLayout;
